import Image from 'next/image'
import React, { memo } from 'react'

import { useIsTabletS } from '@hooks/use-media-query'
import { NormalizedWrapper } from '@theme'

import {
  Wrapper,
  Content,
  TitleWrapper,
  Title,
  Subtitle,
  DEFAULT_HEXAGON_HEIGHT,
  DEFAULT_HEXAGON_WIDTH,
} from './styles'

function CaseTechStackComponent({
  title = 'Technologies',
  subtitle,
  titleColor,
  titleColorMobile,
  subtitleColor,
  subtitleColorMobile,
  maxWidth,
  maxWidthMobile,
  hexagonImg = '/images/empty-hexagon-icon.webp',
  mobileFont,
  mobileFontTitle,
  sizeHexagonMobile,
  sizeHexagon,
}) {
  const isAboveTabletS = useIsTabletS()
  const selectedTitleColor =
    !isAboveTabletS && titleColorMobile ? titleColorMobile : titleColor
  const selectedSubtitleColor =
    !isAboveTabletS && subtitleColorMobile ? subtitleColorMobile : subtitleColor

  const currentHexagonWidth =
    (sizeHexagon && sizeHexagon.width) || DEFAULT_HEXAGON_WIDTH
  const currentHexagonHeight =
    (sizeHexagon && sizeHexagon.height) || DEFAULT_HEXAGON_HEIGHT

  return (
    <NormalizedWrapper paddingValue="0">
      <Wrapper>
        <Content maxWidth={maxWidth} $maxWidthMobile={maxWidthMobile}>
          <TitleWrapper $sizeHexagonMobile={sizeHexagonMobile}>
            <Image
              src={hexagonImg}
              width={currentHexagonWidth}
              height={currentHexagonHeight}
              alt="hexagon-icon"
              quality={90}
            />
            <Title
              as="h2"
              $mobileFontTitle={mobileFontTitle}
              color={selectedTitleColor}
            >
              {title}
            </Title>
          </TitleWrapper>
          <Subtitle
            as="span"
            $mobileFont={mobileFont}
            color={selectedSubtitleColor}
          >
            {subtitle}
          </Subtitle>
        </Content>
      </Wrapper>
    </NormalizedWrapper>
  )
}

export const CaseTechStack = memo(CaseTechStackComponent)
